import typeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  SET_EXCHANGE_FILTERS,
  SET_EXCHANGE_PAGINATION,
  GET_EXCHANGE,
  RESET_EXCHANGE_LIST,
} from 'exchange/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const exchange = new schema.Entity('exchange');

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getRejected = (state) => ({ ...state, isLoading: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize({ exchange: payload.records }, { exchange: [exchange] }),
});

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['origin', 'final', 'date', 'value'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { exchange: {} },
  result: { exchange: [] },
};

const reducers = {
  [RESET_EXCHANGE_LIST]: reset,
  [SET_EXCHANGE_FILTERS]: setFilters,
  [SET_EXCHANGE_PAGINATION]: setPagination,
  [GET_EXCHANGE]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
};

export default typeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/reducers/exchange_list_reducers.js